/* unplugin-vue-components disabled */import { render } from "./UserItem.vue?vue&type=template&id=4a09274a&scoped=true&ts=true"
import script from "./UserItem.vue?vue&type=script&lang=ts"
export * from "./UserItem.vue?vue&type=script&lang=ts"

import "./UserItem.vue?vue&type=style&index=0&id=4a09274a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a09274a"]])

export default __exports__